import { connectCurrentRefinements } from 'instantsearch.js/es/connectors'
import { get } from '@bigyouth/base'

const renderCurrentRefinements = (renderOptions, isFirstRender) => {
  const { items } = renderOptions

  let count = 0
  const counter = get('.filter-button__counter')

  items.forEach(item => {
    count += item.refinements.length
  })

  if (count > 0) {
    counter.classList.add('is-visible')
    counter.innerHTML = count
  } else {
    counter.classList.remove('is-visible')
  }
}

const customCurrentRefinements = connectCurrentRefinements(renderCurrentRefinements)

export default customCurrentRefinements
